<template>
  <div class="cf-node-properties__input">
    <SearchableDropdown
      v-model="selectValue"
      :config="config"
      :rules="rules"
      :searchable="searchable"
      :clearable="clearable"
      class="m-0 form__searchable-dropdown"
    />
    <slot />
    <div
      v-if="errorMessage" 
      class="cf-node-properties__input-error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'InputSearchableSelect',
  components: { 
    SearchableDropdown 
  },
  props: {
    value: {
      type: [String, Number, Object],
      default() {
        return null;
      }
    },
    placeholder: {
      type: [String, Number],
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default() {
        return null;
      }
    },
    error: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    selectValue: {
      get() { 
        return this.value; 
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    rules() {
      return this.required ? 'required' : '';
    },
    errorMessage() {
      return this.error?.errorMessage;
    }
  }
};
</script>